import * as atlas from "azure-maps-control";

import { MapLocationType } from "./MapView";

export const getMapBoundsDistance = (mapRef: atlas.Map | null, mapLocation: MapLocationType) => {
  if (!mapRef) {
    return;
  }

  const camera = mapRef.getCamera();
  const bounds = camera.bounds;
  const center = camera.center;
  const zoom = camera.zoom;

  let maxDistanceInMiles;
  if (bounds && center) {
    const corners = [
      [bounds[0], bounds[3]],
      [bounds[2], bounds[3]],
      [bounds[0], bounds[1]],
      [bounds[2], bounds[1]],
    ];

    const maxDistanceInMeters = Math.max(...corners.map((corner) => atlas.math.getDistanceTo(mapLocation.coordinates, corner)));
    maxDistanceInMiles = atlas.math.convertDistance(maxDistanceInMeters, "meters", "miles");
  }

  return {
    bounds,
    center,
    zoom,
    maxDistanceInMiles,
  };
};
